import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    
    .modal{
        width: 600px;
        height: 500px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        overflow: auto;
        border-radius: 10px;
        padding-top: 20px;
        position: relative;
        .content{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            gap: 20px;
            padding: 30px;
            .detail-container{
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 15px;
                .row{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    p{
                        font-size: var(--font-size-md);
                        font-weight: var(--font-weight-lg);
                    }
                    span{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }
                }
            }
            .btn-container{
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 20px;
                position: sticky;
                bottom: 0px;
                width: 100%;
                background-color: #fff;
                border-top: 1px solid ${({ theme }) => theme.mainBorderColor};
                padding-block: 10px;
            }
        }
    }

`

const RentalCarOptionsModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const {selectRentalCar } = useSelector(state => state.ilanlar)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const storageUserId = JSON.parse(storage.getItem("userId"));
    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


  return (
    <Container onClick={() => dispatch(showModal(null)) }>
        <div className="modal" onClick={(e)=>{e.stopPropagation(); dispatch(handleActiveSelect(null))}} >
            <PageTopTitle isDiffPage title={"Kiralık Araç Ayarlar"}/>
            <div className="content">
            <div className="detail-container">
                    <div className="row">
                        <p>Araç Türü:</p>
                        <span>{selectRentalCar?.vehicleType}</span>
                    </div>
                    <div className="row">
                        <p>Araç Kasa Tipi:</p>
                        <span>{selectRentalCar?.bodyType}</span>
                    </div>
                    <div className="row">
                        <p>Sürücülü/Sürücüsüz:</p>
                        <span>{selectRentalCar?.driverType}</span>
                    </div>
                    <div className="row">
                        <p>Çalışılacak il:</p>
                        <span>{selectRentalCar?.workCity}</span>
                    </div>
                    <div className="row">
                        <p>Çalışılacak Güzergah:</p>
                        <span>{selectRentalCar?.workRoute}</span>
                    </div>
                    <div className="row">
                        <p>Talep Edilen Yakıt Yüzdesi:</p>
                        <span>{selectRentalCar?.fuelPercentage}</span>
                    </div>
                    <div className="row">
                        <p>Talep Edilen Aylık Kira Bedeli (KDV Hariç):</p>
                        <span>{selectRentalCar?.rentalPrice}</span>
                    </div>
                    <div className="row">
                        <p>Aranacak Telefon:</p>
                        <span>{selectRentalCar?.advertiserPhoneNumber}</span>
                    </div>
                    <div className="row">
                        <p>İlan Sahibi:</p>
                        <span>{selectRentalCar?.advertOwner}</span>
                    </div>
                </div>
                <div className="btn-container">
                    {selectRentalCar?.isApproved === 0 && <Button width="200px" handleClick={() => dispatch(showModal("advertRentalCarUpdate"))} padding="10px" background="#fff" color={"#E85446"}>İlanı Güncelle</Button>}
                    {selectRentalCar?.userId === storageUserId && <Button width="200px" handleClick={() => dispatch(showModal("advertReasonForDelete"))} padding="10px" background="#fff" color={"#E85446"}>İlanı Sil</Button>}
                    <Button width="200px" handleClick={() => dispatch(showModal(null))} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default RentalCarOptionsModal